import { createContext } from 'react'
import { Language } from '~/utils/Translator'

export const LanguageContext = createContext<{ language: Language }>({
  language: 'en',
})
